import { combineReducers } from 'redux';
import actions from '../actions/actionTypes';

const team = (state = [], action) => {
  switch (action.type) {
    case actions.GET_USER_TEAM_SUCCESS:
      return action.team;
    default:
      return state;
  }
};

const accountUser = (state = [], action) => {
  switch (action.type) {
    case actions.CREATE_ACCOUNT_USER_SUCCESS:
      return action.accountUser;
    default:
      return state;
  }
};

const licensedProducts = (state = [], action) => {
  switch (action.type) {
    case actions.GET_LICENSED_PRODUCT_SUCCESS:
      return action.licensedProducts;
    default:
      return state;
  }
};

const accountUsers = (state = [], action) => {
  switch (action.type) {
    case actions.GET_ACCOUNT_USERS_SUCCESS:
      return action.accountUsers;
    default:
      return state;
  }
};

const accountSummary = (state = [], action) => {
  switch (action.type) {
    case actions.GET_ACCOUNT_SUMMARIES_SUCCESS:
      return action.accountSummary;
    default:
      return state;
  }
};

const scoutRoles = (state = [], action) => {
  switch (action.type) {
    case actions.GET_FASTSCOUT_ROLES_SUCCESS:
      return action.scoutRoles;
    default:
      return state;
  }
};

const accessRoles = (state = [], action) => {
  switch (action.type) {
    case actions.GET_FASTACCESS_ROLES_SUCCESS:
      return action.accessRoles;
    default:
      return state;
  }
};

const recruitRoles = (state = [], action) => {
  switch (action.type) {
    case actions.GET_FASTRECRUIT_ROLES_SUCCESS:
      return action.recruitRoles;
    default:
      return state;
  }
};

const loginExpired = (state = null, action) => {
  switch (action.type) {
    case actions.LOGIN_EXPIRED:
      return true;
    default:
      return state;
  }
};
const rootReducer = combineReducers({
  team,
  accountUser,
  licensedProducts,
  scoutRoles,
  accessRoles,
  recruitRoles,
  loginExpired,
  accountUsers,
  accountSummary
});

export default rootReducer;
